// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ld-c";
export var backButton = "_ld-4";
export var backIcon = "_ld-5";
export var chevronShortcut = "_ld-6";
export var container = "_ld-1";
export var editor = "_ld-8";
export var editorWrapper = "_ld-7";
export var prefix = "_ld-2";
export var searchIcon = "_ld-3";
export var suffix = "_ld-9";
export var suffixContent = "_ld-a";
export var suffixText = "_ld-b";
export var wrapper = "_ld-0";